/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  ErrorHoldersPlugin,
  IErrorHoldersPluginMethods,
  HeaderHoldersPlugin,
  IHeaderHoldersPluginMethods,
  LoadingHoldersPlugin,
  ILoadingHoldersPluginMethods,
  HoldersListPlugin,
  IHoldersListPluginMethods,
  SettingsHoldersPlugin,
  ISettingsHoldersPluginMethods,
  StaticHoldersPagePlugin,
  IStaticHoldersPagePluginMethods,
  ResendCredentialsPlugin,
  IResendCredentialsPluginMethods,
  RevokeCredentialsPlugin,
  IRevokeCredentialsPluginMethods,
  IssuedListPlugin,
  IIssuedListPluginMethods,
} from './plugins';

export type TAgent = IResendCredentialsPluginMethods &
  IErrorHoldersPluginMethods &
  IHeaderHoldersPluginMethods &
  ILoadingHoldersPluginMethods &
  IHoldersListPluginMethods &
  ISettingsHoldersPluginMethods &
  IStaticHoldersPagePluginMethods &
  IRevokeCredentialsPluginMethods &
  IIssuedListPluginMethods;

const getPlugins = () => {
  return [
    new StaticHoldersPagePlugin(),
    new ErrorHoldersPlugin(),
    new LoadingHoldersPlugin(),
    //Business logic plugins !
    new ResendCredentialsPlugin(),
    new HeaderHoldersPlugin(),
    new HoldersListPlugin(),
    new SettingsHoldersPlugin(),
    new RevokeCredentialsPlugin(),
    new IssuedListPlugin(),
  ];
};

export const getAgent = () => {
  return createAgent<TAgent>({
    plugins: getPlugins(),
  });
};
